import Handlebars from 'handlebars/dist/handlebars.min';
import {fieldValAsString, toBool} from "../components/utils";
import _ from 'lodash';
// import Showdown from 'showdown';
import { stripHtml } from "string-strip-html";
import {convertMDToHTML} from "./convertMDToHTML";

export const fix = (template, data, ignoreKeys = []) => {
    if(!_.isString(template))return `${(template === undefined || template === null) ? '' : template }`
    let keys = Object.keys(data).sort( (a,b) => a.length > b.length ? -1 : 1)
    //want longer names first to convert them
    template = convertFields( template, data)
    for(let key of keys){
        if(ignoreKeys.includes(key.toLowerCase()))continue
        let regex = null
        let start = "["
        let end = "]"
        if(_.startsWith(key,start) && _.endsWith(key,end)){
            start = "'"
            end = "'"
        }
        let regKey = escapeRegExp( key )
        regex = new RegExp(`{{${regKey}}}`,'ig')
        template = template.replace(regex,`{{${start}${key}${end}}}`)
        regex = new RegExp(`{{${regKey} `,'ig')
        template = template.replace(regex,`{{${start}${key}${end} `)
        regex = new RegExp(` ${regKey}}}`,'ig')
        template = template.replace(regex,` ${start}${key}${end}}}`)
        regex = new RegExp(`\\[${regKey}\\]`,'ig')
        template = template.replace(regex,`[${key}]`)

    }

    return template
}
export const escapeRegExp = (content) => {
    return content.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
export const convertText = (template,data) => {
    const {output, error} = convertTemplate( {template, data, format: 'text', output_format: 'text'})
    return output
}

export const setHelpers = (hb, format) => {
    const add = (keys, func) => {
        if(_.isString(keys))keys = keys.split(",")
        for(let key of keys){
            hb.registerHelper(key.trim(), (src, options) => {
                if(!options){
                    options = src
                    src = options['value'] === undefined ? get(options?.hash?.field || '', options, true) : options['value']

                }
                return func(src,options)
            })
        }
    }
    const context = (options) => {
        return options?.fn ? options.fn(options?.data.root) : ""
    }
    const strict = (options) => format === 'markdown' && toBool( get( options?.hash.strict || '0', options) , false )
    const get = (val, options, valIsRaw = false) => {
        let getVal = `${val}`.trim()
        if(valIsRaw || (_.startsWith(getVal, '{{') && _.endsWith(getVal, '}}'))){
            if(!valIsRaw) {
                getVal = getVal.substr(2, getVal.length - 4)
                if (_.startsWith(getVal, "'[") && _.endsWith(getVal, "]'")) {
                    getVal = getVal.substr(1, getVal.length - 2)
                } else if (_.startsWith(getVal, '[') && _.endsWith(getVal, ']')) {
                    getVal = getVal.substr(1, getVal.length - 2)
                }
            }
            let path = ['data','root',...getVal.split(".")]
            return _.get(options, path, '')
        }
        return val
    }
    add( ":field, :field:", function(src, options) {
        const cx = context(options)
        let out = src || cx ||  get( options.hash.key , options, true )
        let separator = get( options?.hash.sep || options?.hash.separator || ' ', options)
        out = fieldValAsString( out, separator)
        return out
    })

    add( ":strip,:strip:", function(src, options) {
        let stripOptions = {}
        if(toBool(options?.hash?.links, false))stripOptions['dumpLinkHrefsNearby'] = true
        const cx = context(options)
        let html = get( src || options?.hash?.value || cx || '', options )
        const {result} = stripHtml(html, stripOptions)
        return result
    })
    add(":if,:if:", function(src, options) {

        const cx = context(options)
        let ifVal = get( src || options?.hash.value || cx ||  '', options )
        let elseVal = get( options?.hash.else || options?.hash.or || '', options)
        let before = get( options?.hash.before || '', options)
        let after = get( options?.hash.after || '', options)
        return (_.isEmpty(ifVal) ? elseVal : before + ifVal + after)
    })

    console.log("Setting Helpers", format)
    add(":image,:image:", function(src,options) {

        const cx = context(options)
        let field = get(options?.hash.field, options)
        let target = get(options?.hash.target || '_blank', options)
        let label = get( options?.hash.label || '', options)
        let link = get( options?.hash.link, options)
        let pick = get( options?.hash.pick || 'first', options)
        let style = get( options?.hash.style || '', options)
        let size = get( options?.hash.size || 'large', options)
        let strictMd = strict(options)
        let item = _pick( src, pick )
        let imgUrl = _.get(item,`thumbnails.${size}.url`)
        let out = ''
        if(link && !strictMd){
            out += `<a href="${link}" target="${target}">${label}`
        }
        out += strictMd ? `![](${imgUrl})` : `<img src="${imgUrl}" style="${style}"/>`
        if(link){
            if(strictMd) {
                out =  `[${out}](${link})`
            }else{
                out += "</a>"
            }
        }
        return new hb.SafeString(out);
    });
    add(":images,:images:", function(src, options) {
        const cx = context(options)
        let strictMd = strict(options)
        let field = get(options?.hash.field, options)
        let style = get( options?.hash.style || '', options)
        let size =get( options?.hash.size || 'large', options)
        let separator = get( options?.hash.sep || options?.hash.separator || '', options)
        let empty = get( options?.hash.empty || options?.hash.empty_msg || '', options)
        let out = ''
        if(Array.isArray(src) && src.length){
            src.map( item => {
                let imgUrl = _.get(item,`thumbnails.${size}.url`)
                if(imgUrl){
                    out += `${out ? '' : separator}${strictMd ? `![](${imgUrl})` : `<img src="${imgUrl}" style="${style}"/>`}`
                }

            })
        }else if(empty)out = empty

        return new hb.SafeString(out);
    });
    add(":url,:url:", function(src,options) {

        const cx = context(options)
        let field = get(options?.hash.field, options)
        let pick = get( options?.hash.pick || 'first', options)
        let size = get( options?.hash.size || 'large', options)
        let item = _pick( src, pick )
        let imgUrl = _.get(item,`thumbnails.${size}.url`)
        let out = imgUrl
        console.log("Processing URL", field, imgUrl)
        return new hb.SafeString(out);
    });
    add(":urls,:urls:", function(src, options) {
        const cx = context(options)
        let size =get( options?.hash.size || 'large', options)
        let separator = get( options?.hash.sep || options?.hash.separator || '', options)
        let empty = get( options?.hash.empty || options?.hash.empty_msg || '', options)
        let out = ''
        if(Array.isArray(src) && src.length){
            src.map( item => {
                let imgUrl = _.get(item,`thumbnails.${size}.url`)
                if(imgUrl){
                    out += `${out ? '' : separator}${imgUrl}`
                }

            })
        }else if(empty)out = empty

        return new hb.SafeString(out);
    });
    add(":link:,:link", function(src,options) {
        const cx = context(options)
        let strictMd = strict(options)
        let target = get( options?.hash.target || '_blank', options)
        let label = get( options?.hash.label || cx || 'Click Here', options)
        let url = get( options?.hash.url || options?.hash.href, options)
        let style = get( options?.hash.style || '', options)
        let altText = get( options?.hash.alt_text || (options?.hash.label ? cx : ''), options)
        let out = ''
        out += url ? (strictMd ? `[${label}](${url})` : `<a href="${url}" target="${target}" style="${style}">${label}</a>`) : altText
        return new hb.SafeString(out);
    });
    add(":links:,:links", function(src,options) {
        const cx = context(options)
        let target = get( options?.hash.target || '_blank', options)
        let strictMd = strict(options)
        let url = get( options?.hash.url || options?.hash.href, options)
        let style = get( options?.hash.style || '', options)
        let altText = get( options?.hash.alt_text || (options?.hash.label ? cx : ''), options)
        let separator = get( options?.hash.sep || options?.hash.separator || ' | ', options)
        let empty = get( options?.hash.empty || options?.hash.empty_msg || '', options)
        let out = ''
        if(Array.isArray(src) && src.length){
            src.map( item => {
                let linkUrl = _.get(item,`url`)
                let label = get( options?.hash.label || cx || _.get(item,`filename`) || 'Click Here', options)
                if(linkUrl)out += `${out ? '' : separator}${strictMd ? `[${label}](${url})` : `<a href="${url}" target="${target}" style="${style}">${label}</a>`}`

            })
        }else if(empty)out = empty


        return new hb.SafeString(out);
    });

}

const _pick = (val, which ) => {
    if(_.isArray(val)) {
        if (!which || which == 'first') {
            val = _.head(val)
        } else if (which === 'random') {
            val = _.sample(val)
        } else if (which === 'last') {
            val = _.last(val)
        } else if (!isNaN(which)) {
            val = _.nth(val, Number(which))
        } else {
            val = _.head(val)//shouldn't happen
        }
        return val
    }
}
export const convertFieldKey = (key, val) => {
    console.log('convertFieldKey', key, val)
    if(Array.isArray(val)){
        const isImg = _.get(val,'0.type', '').includes('image/')
        const hasUrl = !!_.get(val,'0.url', '')
        if(isImg){
            return `{{:images field="${key}"}}`
        }else if(hasUrl){
            return `{{:links field="${key}"}}`
        }
    }else if(_.isPlainObject(val)){
        const isImg = _.get(val,'type', '').includes('image/')
        const hasUrl = !!_.get(val,'url', '')
        if(isImg){
            return `{{:image field="${key}"}}`
        }else if(hasUrl){
            return `{{:link field="${key}"}}`
        }
    }
    //return `{{[${key}]}}`
    return `{{:field key="${key}"}}`
}
export const convertFields = (content, data) => {
    const reg = new RegExp( /\{\{field id="(\S+)" name="(.+?)"\}\}/, 'g')
    let match = null
    let modified = content
    console.log('Converting Fields', content, data)
    while( (match = reg.exec(content)) !== null){
        const [full,id,name] = match
        const newValKey = _.get(data,id) ? id :  _.get(data,name) ? name : ''
        const newVal = _.get(data,newValKey)
        console.log('Found Match', full, id, name, newValKey, newVal)
        modified = modified.replace(full, newValKey ? convertFieldKey(newValKey, newVal) : '')
    }
    console.log('Finished Converting', content, modified)
    return modified
}
export const convertTemplate = content => {
    let error = undefined
    let {
        template = '',
        data = {},
        format_as = 'html',
        render_as = 'html',
    } = content
    if (_.isObject(template) && format_as === 'json') template = JSON.stringify(template)
    if(!_.isString(template))return {output:template, error:null}
    const hb = Handlebars.create()
    setHelpers( hb, format_as )
    template = fix(template, data)
    console.log('HB Template', template)
    let final = ""
    try {
        const tpl = hb.compile(template)
        // const converter = new Showdown.Converter()
        // converter.setFlavor('github')

        let output = tpl(data)
        output = output.replace(new RegExp(/\\n/,'g'), "\n").replace(new RegExp(/\\t/,'g'), "\t")
        final = output
        console.log("HB TEMPLATE", {output, template, data, format_as})
        if (format_as === 'html') {
            if (render_as === 'markdown') {
                // final = converter.makeMarkdown(output)
            }
        } else if (format_as === 'markdown') {
            if (render_as === 'html') {
                // final = converter.makeHtml(output)
                final = convertMDToHTML(output)
            }
        } else if (render_as === 'json') {
            final = JSON.parse(output)
        }
    }catch(err){
        console.log('HB Parse Error', { err: err.message, template, data})
        error = err.message
        final = template
    }

    return {output:final,error}
}

export const getHBValues = (text) => {
    const re = /{{[{]?(.*?)[}]?}}/g;
    const tags = [];
    let matches;
    while ((matches = re.exec(text))) {
        if (matches) {
            tags.push(matches[1]);
        }
    }
    const root = {};
    let context = root;
    const stack = [];
    const setVar = (variable, val) => {

        // Dot Notation Breakdown
        if (variable.match(/\.*\./) && !variable.match(/\s/)) {
            let notation = variable.split('.')
            _.set(context, notation, "")
        }
        else {
            context[variable.trim()] = val;
        }
    };
    for (let tag of tags) {
        if (tag.startsWith('! ')) {
            continue;
        }
        if (tag == 'else') {
            continue;
        }
        if ('#^'.includes(tag[0]) && !tag.includes(' ')) {
            setVar(tag.substr(1), true);
            stack.push(context);
            continue;
        }
        if (tag.startsWith('#if')) {
            const vars = tag.split(' ').slice(1);
            if(vars.length) {
                if(vars[0].startsWith('[') && vars[vars.length-1].endsWith(']')){
                    setVar(vars.join(' '), true)
                }else{
                    for (const v of vars) {
                        setVar(v, true);
                    }

                }
            }
            stack.push(context);
            continue;
        }
        if (tag.startsWith('/if')) {
            context = stack.pop();
            continue;
        }
        if (tag.startsWith('#with ')) {
            const v = tag.split(' ')[1];
            let newContext = {};
            context[v] = newContext;
            stack.push(context);
            context = newContext;
            continue;
        }
        if (tag.startsWith('/with')) {
            context = stack.pop();
            continue;
        }
        if (tag.startsWith('#unless ')) {
            const v = tag.split(' ')[1];
            setVar(v, true);
            stack.push(context);
            continue;
        }
        if (tag.startsWith('/unless')) {
            context = stack.pop();
            continue;
        }
        if (tag.startsWith('#each ')) {
            const v = tag.split(' ')[1];
            const newContext = {};
            context[v] = [newContext];
            stack.push(context);
            context = newContext;
            continue;
        }
        if (tag.startsWith('/each')) {
            context = stack.pop();
            continue;
        }
        if (tag.startsWith('/')) {
            context = stack.pop();
            continue;
        }
        setVar(tag, '');
    }

    return root;
};
